document.addEventListener('DOMContentLoaded', function () {
  // LOTTIE ANIMATIONS
  const lottieElements = document.querySelectorAll('.js-lottie-anim');

  lottieElements.forEach(function (el) {
    const animationPath = el.getAttribute('data-animation-path');
    if (animationPath) {
      lottie.loadAnimation({
        container: el,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: animationPath
      });
    }
  });

  // PDP - INGREDIENTS MODAL
  if(document.querySelector('[data-id="pdp-ingredients-modal"]')!=null){
    const showOverlay = () => document.querySelector(".modal-ingredients-dark-overlay").style.display = "block";
    const showModal = () => document.querySelector(".ingredients-modal-container").style.display = "block";
    const hideOverlay = () => document.querySelector(".modal-ingredients-dark-overlay").style.display = "none";
    const hideModal = () => document.querySelector(".ingredients-modal-container").style.display = "none"; 
  
    // Open the modal window
    document.querySelector("[data-id] .multi-column__item:nth-child(1) .link").onclick = function(e) {
      showOverlay();
      showModal();
      {e.preventDefault();}(event)
    }
  
    // Close the modal window
    document.querySelector(".close-modal-exit").onclick = function() {
      hideOverlay();
      hideModal();
    }
  
    window.onclick = function(event) {
      if(event.target === document.querySelector(".ingredients-modal-container")) {
        hideOverlay();
        hideModal();      
      }
    }
    // console.log("Ayeeeeee!");
  }

  // GLOBAL - OPEN EXTERNAL LINKS IN NEW TAB
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }  
  
});